import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../config/api";
import { BASE_API } from "../../../constants/apiUrls";
import { toast } from "../../../lib/toast";
import {
  CommonOthers,
  ErrorMessage,
  GetCommonData,
  GetSingleDataParams,
  Params,
  PostRequest,
} from "../../../types";
import {
  CreateTrainingMaterial,
  getSingleTrainingMaterial,
  GetTrainingMaterialData,
  GetTrainingMaterialDataParams,
} from "../../../types/trainingMaterial/trainingMaterial";
import { handleApiError } from "../../../utils/errorHandler";

// create
export const createTrainingMaterialAsync = createAsyncThunk<
  null,
  PostRequest<CreateTrainingMaterial, CommonOthers>
>(
  "admin/createTrainingMaterial",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.post(BASE_API.createTrainingMaterial, data, {
        headers: {
          "ngrok-skip-browser-warning": true,
        },
      });

      reRender(true);
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "material create fail");
      return rejectWithValue(error);
    }
  }
);

// get all
export const getAllTrainingMaterialAsync = createAsyncThunk<
  GetCommonData<GetTrainingMaterialData>,
  Params<GetTrainingMaterialDataParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllTrainingMaterial", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as GetTrainingMaterialDataParams;

  try {
    const data = await AXIOS.get(BASE_API.getAllTrainingMaterial, {
      params: { ...rest },
      headers: {
        "ngrok-skip-browser-warning": true,
      },
    });

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get material fail");
    return rejectWithValue(error);
  }
});

// update
export const updateTrainingMaterialAsync = createAsyncThunk<
  null,
  PostRequest<CreateTrainingMaterial, GetSingleDataParams>
>(
  "admin/updateTrainingMaterial",
  async ({ data, others: { reRender, id } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateTrainingMaterial}/${id}`, data, {
        headers: {
          "ngrok-skip-browser-warning": true,
        },
      });

      reRender && reRender(true);
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "material update fail");
      return rejectWithValue(error);
    }
  }
);

// single
export const singTrainingMaterialAsync = createAsyncThunk<
  getSingleTrainingMaterial,
  Params<GetSingleDataParams>
>("admin/singTrainingMaterial", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(
      `${BASE_API.getSingleTrainingMaterial}/${params?.id}`,
      {
        headers: {
          "ngrok-skip-browser-warning": true,
        },
      }
    );

    return data.data?.data as getSingleTrainingMaterial;
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Single material data get fail");
    return rejectWithValue(error);
  }
});
